import { defineStore } from 'pinia'
import { useAuthStore } from '@/stores/user/auth'
import axios from 'axios'

export const usePopoverStore = defineStore({
   id: 'interactions-popover',
   state: () => ({
      showingPopoverID: '',
      storeAuth: useAuthStore(),
   }),
   actions: {
      updatePopover(id) {
         this.showingPopoverID = id
      },
      resetPopovers() {
         this.showingPopoverID = ''
      }
   }
})